import React from 'react';
import { Input, Button, Tooltip } from 'antd';
import { HolderOutlined, DeleteOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

interface SolutionItemProps {
  value: string;
  index: number;
  isDragging: boolean;
  isDragOver: boolean;
  dragOverPosition: 'top' | 'bottom' | null;
  onUpdate: (index: number, value: string) => void;
  onRemove: (index: number) => void;
  onDragStart: (index: number) => void;
  onDragOver: (e: React.DragEvent, index: number) => void;
  onDragLeave: () => void;
  onDrop: (e: React.DragEvent, index: number) => void;
}

export const SolutionItem: React.FC<SolutionItemProps> = ({
  value,
  index,
  isDragging,
  isDragOver,
  dragOverPosition,
  onUpdate,
  onRemove,
  onDragStart,
  onDragOver,
  onDragLeave,
  onDrop,
}) => {
  const { t } = useTranslation();

  return (
    <div
      onDragOver={(e) => onDragOver(e, index)}
      onDragLeave={onDragLeave}
      onDrop={(e) => onDrop(e, index)}
      style={{
        display: 'flex',
        gap: 8,
        alignItems: 'center',
        padding: 8,
        border: '1px dashed #d9d9d9',
        borderRadius: 4,
        marginTop: 0,
        marginBottom: 8,
        background: isDragging ? '#f0fce8' : '#f5f5f5',
        position: 'relative',
        boxShadow: isDragOver ? '0 0 0 2px #9fe97033 inset' : 'none'
      }}
    >
      {isDragOver && (
        <div style={{
          position: 'absolute',
          left: 0,
          right: 0,
          height: 2,
          background: '#9fe970',
          top: dragOverPosition === 'top' ? -4 : undefined,
          bottom: dragOverPosition === 'bottom' ? -4 : undefined
        }} />
      )}
      <span
        draggable
        onDragStart={() => onDragStart(index)}
        style={{ cursor: 'grab', display: 'inline-flex', alignItems: 'center' }}
        aria-label="Drag to reorder"
      >
        <HolderOutlined style={{ color: '#999' }} />
      </span>
      <Input
        value={value}
        onChange={e => onUpdate(index, e.target.value)}
        style={{ flex: 1 }}
      />
      <Tooltip title={t('guides.removeSolution')}>
        <Button danger type="text" icon={<DeleteOutlined />} onClick={() => onRemove(index)} />
      </Tooltip>
    </div>
  );
};